import { render, staticRenderFns } from "./BookingFlowItem.vue?vue&type=template&id=e8fcb912"
import script from "./BookingFlowItem.vue?vue&type=script&lang=js"
export * from "./BookingFlowItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports